/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXyVUpIcon24Solid = forwardRef('DataChartBarsXyVUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3 1.875c.621 0 1.125.504 1.125 1.125v15c0 1.035.84 1.875 1.875 1.875h16a1.125 1.125 0 0 1 0 2.25H6A4.125 4.125 0 0 1 1.875 18V3c0-.621.504-1.125 1.125-1.125Z" }),
        React.createElement("path", { d: "M8 10.875c.621 0 1.125.504 1.125 1.125v4a1.125 1.125 0 0 1-2.25 0v-4c0-.621.504-1.125 1.125-1.125Z" }),
        React.createElement("path", { d: "M17.125 6a1.125 1.125 0 0 0-2.25 0v10a1.125 1.125 0 0 0 2.25 0V6Z" }),
        React.createElement("path", { d: "M20 1.875c.621 0 1.125.504 1.125 1.125v13a1.125 1.125 0 0 1-2.25 0V3c0-.621.504-1.125 1.125-1.125Z" }),
        React.createElement("path", { d: "M13.125 9a1.125 1.125 0 0 0-2.25 0v7a1.125 1.125 0 0 0 2.25 0V9Z" })));
});
